$(document).ready(function () {
  $(".custLvRweNw").find(".color-scheme-1").removeClass("color-scheme-1");
  $(".custLvRweNw").find(".gradient").removeClass("gradient");
  $(".custLvRweNw").parents("section").addClass("custLvRweNwPrnt");
  $("#custStaticPro").appendTo(".custProPfloMnBtm");
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".input-prt, .search-btn").length) {
      setTimeout(() => {
        $(".input-prt")
          .stop(true, true)
          .css({ overflow: "hidden" })
          .animate(
            { width: "0px", opacity: 0 },
            {
              duration: 400,
              easing: "swing",
              complete: function () {
                $(this).hide();
              },
            },
          );
      }, 50);
    }
  });

  $("#custNotifyMeBtn").click(function () {
    $("body").addClass("NotifyModelOpen");
  });
  $(".custSnglProPrc.custOutofStcTxt p span").click(function () {
    $("body").addClass("NotifyModelOpen");
  });
  $(".custNotifyMeMainDvCldTp a img").click(function () {
    $("body").removeClass("NotifyModelOpen");
  });
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
        var targetId = this.getAttribute("href").substring(1);
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
          e.preventDefault();
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: "smooth",
          });
        }
      });
    });
  });

  let yotpoCheck = setInterval(function () {
    let reviews = $(
      ".custAllReviewYopto .yotpo-reviews.yotpo-active .yotpo-review.yotpo-regular-box",
    );
    if (reviews.length) {
      reviews.each(function () {
        let mainBox = $(this).find(".yotpo-main");
        $(this).find(".yotpo-header .yotpo-user-name").appendTo(mainBox);
        $(this).find(".yotpo-header .yotpo-review-date").appendTo(mainBox);
      });
      clearInterval(yotpoCheck);
    }
  }, 500);

  jQuery(function ($) {
    var checkExist = setInterval(function () {
      var $container = $(
        ".custAllReviewYopto form #write-review-tabpanel-main-widget",
      );
      if ($container.length && !$container.find(".custLeftReviewLft").length) {
        var $leftDiv = $('<div class="custLeftReviewLft"></div>');
        var $rightDiv = $('<div class="custRightReviewRt"></div>');
        $container.append($leftDiv, $rightDiv);
        $leftDiv.append($container.find(".yotpo-header"));
        $rightDiv.append(
          $container.find(".write-review-content"),
          $container.find(".yotpo-footer.yotpo-animation-opacity.visible"),
          $container.find(".form-element.submit-button"),
        );

        clearInterval(checkExist);
      }
    }, 500);
  });

  let custVideo = $(".custHomeVideoSection deferred-media");
  $(custVideo).appendTo(".custHomeVideoSection");
  let custVideo2 = $(".custAboutSec1 deferred-media");
  $(custVideo2).appendTo(".custAboutSec1");
  let custTagh2 = $(".custAboutSec1 .custVideoTxtDataCld .title-wrapper h2");
  $(custTagh2).appendTo(".custAboutSec1 .isolate.page-width");
  let custTxt2 = $(".custAboutSec1 .custVideoTxtDataCld p");
  $(custTxt2).appendTo(".custAboutSec1 .isolate.page-width");

  function moveEmptyBtn() {
    const emptyBtn = document.querySelector(
      ".oke-state-empty, .oke-w-reviews-writeReview",
    );
    const target = document.querySelector(".custLvRweNw .rich-text__text");
    if (emptyBtn && target) {
      target.appendChild(emptyBtn);
      observer.disconnect();
    }
  }
  const observer = new MutationObserver(() => {
    moveEmptyBtn();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  $(".custLvRweNw .rich-text__buttons a.button").click(function () {
    $(this).parents(".custLvRweNw").toggleClass("active");
  });

  $(".custLvRweNw .rich-text__buttons a.button").click(function () {
    $(this).parents(".custLvRweNw").addClass("custEmptyBtnClicked");
  });

  $(".rich-text__buttons a.button.button--primary").click(function () {
    $(this).parents(".custLvRweNw").removeClass("custEmptyBtnClicked");
  });

  $(document).on("click", ".custLvRweNw .oke-state-empty", function () {
    $(this).parents(".custLvRweNw").addClass("custEmptyBtnClicked");
  });
  $(document).on(
    "click",
    ".custLvRweNw .oke-w-reviews-writeReview",
    function () {
      $(this).parents(".custLvRweNw").addClass("custEmptyBtnClicked");
    },
  );

  gsap.registerPlugin(ScrollTrigger);
  document
    .querySelectorAll(".second-section .top-part h2")
    .forEach((container) => {
      const html = container.innerHTML;
      container.innerHTML = "";
      html.split(/(<br\s*\/?>)/gi).forEach((part) => {
        if (part.match(/<br\s*\/?>/i)) {
          container.appendChild(document.createElement("br"));
        } else {
          part.split("").forEach((char) => {
            const span = document.createElement("span");
            span.textContent = char;
            span.style.opacity = 0;
            container.appendChild(span);
          });
        }
      });
      const spans = container.querySelectorAll("span");
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 90%",
          end: "top 40%",
          scrub: true,
        },
      });
      tl.to(spans, {
        opacity: 1,
        ease: "none",
        stagger: {
          each: 0.02,
          from: "start",
        },
      });
    });

  let mm = gsap.matchMedia();

  mm.add("(max-width: 767px)", () => {
    const triggers = [];

    document.querySelectorAll(".custPushSwtchSec8").forEach((section) => {
      const sliderWrap = section.querySelector(".custom-slider-init");

      if (!sliderWrap) return;

      const getScrollAmount = () => {
        return sliderWrap.scrollWidth - window.innerWidth;
      };

      if (getScrollAmount() <= 0) return;

      const tween = gsap.to(sliderWrap, {
        x: () => -getScrollAmount(),
        ease: "none",
        scrollTrigger: {
          trigger: section,
          pin: true,
          pinSpacing: true,
          scrub: 1,
          start: "top top",
          end: () => "+=" + Math.min(getScrollAmount(), 800),
          invalidateOnRefresh: true,
        },
      });

      triggers.push(tween.scrollTrigger);
    });

    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });

    return () => {
      triggers.forEach((trigger) => trigger.kill());
      gsap.set(".custPushSwtchSec8 .custom-slider-init", { clearProps: "all" });
    };
  });
  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });

  document
    .querySelectorAll(".second-section .top-part h1")
    .forEach((container) => {
      const html = container.innerHTML;
      container.innerHTML = "";
      html.split(/(<br\s*\/?>)/gi).forEach((part) => {
        if (part.match(/<br\s*\/?>/i)) {
          container.appendChild(document.createElement("br"));
        } else {
          part.split("").forEach((char) => {
            const span = document.createElement("span");
            span.textContent = char;
            span.style.opacity = 0;
            container.appendChild(span);
          });
        }
      });
      const spans = container.querySelectorAll("span");
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 90%",
          end: "top 40%",
          scrub: true,
        },
      });
      tl.to(spans, {
        opacity: 1,
        ease: "none",
        stagger: {
          each: 0.02,
          from: "start",
        },
      });
    });

  document
    .querySelectorAll(".custHomeSec4 .rich-text__blocks .rich-text__heading")
    .forEach((container) => {
      const html2 = container.innerHTML;
      container.innerHTML = "";

      html2.split(/(<br\s*\/?>)/gi).forEach((part) => {
        if (part.match(/<br\s*\/?>/i)) {
          container.appendChild(document.createElement("br"));
        } else {
          part.split("").forEach((char) => {
            const span = document.createElement("span");
            span.textContent = char;
            container.appendChild(span);
          });
        }
      });

      gsap.to(container.querySelectorAll("span"), {
        opacity: 1,
        stagger: 0.02,
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
        },
      });
    });

  gsap.to(".after-image-wrapper", {
    width: "100%",
    ease: "none",
    scrollTrigger: {
      trigger: ".after-image-wrapper",
      start: "top 95%",
      end: "top 40%",
      scrub: true,
    },
  });

  if (window.innerWidth <= 767) {
    function createAnimation(selector, animationProps) {
      document.querySelectorAll(selector).forEach((el) => {
        const animation = gsap.from(el, {
          ...animationProps,
          paused: true,
        });

        ScrollTrigger.create({
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none none",
          onEnter: () => animation.play(),
          onEnterBack: () => animation.play(),
        });
      });
    }

    function checkVisibleElements() {
      const elements = document.querySelectorAll(
        [
          ...mobileFadeUpClasses,
          ...mobileRtlClasses,
          ...mobileLtrClasses,
          ...mobileTtbClasses,
        ].join(","),
      );

      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const triggerPoint = window.innerHeight * 0.85;

        if (rect.top < triggerPoint && rect.bottom > 0) {
          if (mobileFadeUpClasses.some((cls) => el.matches(cls))) {
            gsap.from(el, {
              opacity: 0,
              y: 50,
              duration: 1,
              ease: "power2.out",
              delay: 0.1,
            });
          } else if (mobileRtlClasses.some((cls) => el.matches(cls))) {
            gsap.from(el, {
              opacity: 0,
              x: 100,
              duration: 1,
              ease: "power2.out",
              delay: 0.1,
            });
          } else if (mobileLtrClasses.some((cls) => el.matches(cls))) {
            gsap.from(el, {
              opacity: 0,
              x: -100,
              duration: 1,
              ease: "power2.out",
              delay: 0.1,
            });
          } else if (mobileTtbClasses.some((cls) => el.matches(cls))) {
            gsap.from(el, {
              opacity: 0,
              y: -50,
              duration: 1,
              ease: "power2.out",
              delay: 0.1,
            });
          }
        }
      });
    }

    const mobileFadeUpClasses = [
      "#Banner-template--17529979502694__image_banner_cL7Crn .banner__box h2",
      ".second-section .bottom-part .left-part p",
      ".second-section .bottom-part .right-part p",
      ".custHomeVideoSection .custVideoTxtData h2",
      ".custHomeVideoSection .custVideoTxtData p",
      ".custHomeSec3 .multicolumn slider-component ul li .multicolumn-card__info",
      ".custHomeSec4 .rich-text__blocks .rich-text__text.rte",
      ".custHomeSec6 .custVideoTxtDataCld h2",
      ".custHomeSec6 .custVideoTxtDataCld p",
      "#shopify-section-template--17529979502694__newsletter_wGRhcV .newsletter .newsletter__wrapper h2",
      "#shopify-section-template--17529979502694__newsletter_wGRhcV .newsletter .newsletter__wrapper .newsletter__subheading p",
      ".custHomeSec3 .multicolumn slider-component ul li:nth-child(2)",
      ".custMmbrProfile",
      ".bio",
      ".content-partCld",
      "footer .container",
      ".custRoadmapSec1 .page-width",
      ".valley-header",
      ".valley-info-box",
      ".valley-description",
      ".valley-bottom p",
      ".custSustainabilitySec1 .banner .banner__content .banner__box h2",
      ".custPrivacySec3 .multicolumn ul li .multicolumn-card h3",
      ".custPrivacySec3 .multicolumn ul li .multicolumn-card .rte",
      ".custPrivacySec3 .multicolumn ul li .multicolumn-card a.link",
      ".custSprtBnrCntnt",
      ".custSupportSec2GrdRpt",
      ".custProductPageBnr.custSustainabilitySec1 .banner .banner__content .banner__text p",
      ".custProductVideoSecCld h2",
      ".custSnglProSec3MnRtTp h2",
      ".custSnglProSec3MnRtTp p",
      ".custSnglProSec3MnRtBtm ul li",
      ".custSnglProSec4MnTxt",
      ".custSnglProTpRtProCat",
      ".custProTTll",
      ".custSnglProDscMn",
      ".custSnglProWrnty",
      ".custSHowVarients .variant-options",
      ".custProShrtDscCld",
      ".custCartPgeTopData h5",
      ".custCartPgeTopData h1",
      ".custCartPgeTopData h4",
      "form#cart table thead tr",
      "form#cart table tbody tr",
      ".custCartRelativeProTtl h3",
      ".custCartMnPageeRtTp h2",
      ".custCartMnPageeRtBtm table",
      ".custCartMnPageeRtBtm .cart-checkout-button",
      ".custContinewShpngg",
      ".custContinewShpnggList",
      ".custBlgBnrData",
      ".custAllBlogsSecDataTp",
      ".custAllBlogsSecDataBtmLft",
      ".custSingleBlogBanner .slideshow__text-wrapper.banner__content .slideshow__text.banner__box",
      ".custAthrTpData",
      ".custContentLeft",
      ".custContentRight",
    ];

    mobileFadeUpClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none none",
            invalidateOnRefresh: true,
          },
          opacity: 0,
          y: 50,
          duration: 1,
          ease: "power2.out",
        });
      });
    });

    const mobileRtlClasses = [
      ".custHomeSec5 .gallery-item",
      ".custHomeSec7 ul li",
      ".custHomeSec2 ul li:last-child",
      ".custom-bottom-image",
      ".coming-from-right",
      ".image-slide-right",
      ".custHomeSec6 .video-section deferred-media.video-section__media",
      ".custHomeSec3 .multicolumn slider-component ul li:nth-child(3)",
      ".custAboutSec1 .isolate p",
      ".custSustainabilitySec4 slider-component ul.multicolumn-list li.multicolumn-list__item",
      ".custProPfloMnTpRt",
      ".custSnglProSec4MnRpt",
      ".custAllBlogsSecDataBtmRt",
      ".custSingleBlogSec2",
    ];

    mobileRtlClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none none",
            invalidateOnRefresh: true,
          },
          opacity: 0,
          x: 100,
          duration: 1,
          ease: "power2.out",
        });
      });
    });

    const mobileLtrClasses = [
      ".custHomeSec2 ul li:first-child",
      ".custHomeSec3 .multicolumn slider-component ul li:nth-child(1)",
      ".custAboutSec1 .isolate h2",
      ".image-with-text-logos .image-part img",
      ".custAboutSec4.custSustainabilitySec5 .image-with-text-logos .image-part img",
      ".custProPfloMnTpLft",
      ".custSnglProSec3MnLft",
    ];

    mobileLtrClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none none",
            invalidateOnRefresh: true,
          },
          opacity: 0,
          x: -100,
          duration: 1,
          ease: "power2.out",
        });
      });
    });
    window.addEventListener("load", function () {
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
    });

    const images = document.querySelectorAll("img");
    let imagesLoaded = 0;
    images.forEach((img) => {
      if (img.complete) {
        imagesLoaded++;
      } else {
        img.addEventListener("load", () => {
          imagesLoaded++;
          if (imagesLoaded === images.length) {
            ScrollTrigger.refresh();
          }
        });
      }
    });
  } else {
    const animatedClasses = [
      "#Banner-template--17529979502694__image_banner_cL7Crn .banner__box h2",
      ".second-section .bottom-part .left-part p",
      ".second-section .bottom-part .right-part p",
      ".custHomeVideoSection .custVideoTxtData h2",
      ".custHomeVideoSection .custVideoTxtData p",
      ".custHomeSec3 .multicolumn slider-component ul li .multicolumn-card__info",
      ".custHomeSec4 .rich-text__blocks .rich-text__text.rte",
      ".custHomeSec6 .custVideoTxtDataCld h2",
      ".custHomeSec6 .custVideoTxtDataCld p",
      "#shopify-section-template--17529979502694__newsletter_wGRhcV .newsletter .newsletter__wrapper h2",
      "#shopify-section-template--17529979502694__newsletter_wGRhcV .newsletter .newsletter__wrapper .newsletter__subheading p",
      ".custHomeSec3 .multicolumn slider-component ul li:nth-child(2)",
      ".custMmbrProfile",
      ".bio",
      ".content-partCld",
      //'footer .container',
      ".custRoadmapSec1 .page-width",
      ".valley-header",
      ".valley-info-box",
      ".valley-description",
      ".valley-bottom p",
      ".custSustainabilitySec1 .banner .banner__content .banner__box h2",
      ".custPrivacySec3 .multicolumn ul li .multicolumn-card h3",
      ".custPrivacySec3 .multicolumn ul li .multicolumn-card .rte",
      ".custPrivacySec3 .multicolumn ul li .multicolumn-card a.link",
      ".custSprtBnrCntnt",
      ".custSupportSec2GrdRpt",
      ".custProductPageBnr.custSustainabilitySec1 .banner .banner__content .banner__text p",
      ".custProductVideoSecCld h2",
      ".custSnglProSec3MnRtTp h2",
      ".custSnglProSec3MnRtTp p",
      ".custSnglProSec3MnRtBtm ul li",
      ".custSnglProSec4MnTxt",
      ".custSnglProTpRtProCat",
      ".custProTTll",
      ".custSnglProDscMn",
      ".custSnglProWrnty",
      ".custSHowVarients .variant-options",
      ".custProShrtDscCld",
      ".custCartPgeTopData h5",
      ".custCartPgeTopData h1",
      ".custCartPgeTopData h4",
      "form#cart table thead tr",
      "form#cart table tbody tr",
      ".custCartRelativeProTtl h3",
      ".custCartMnPageeRtTp h2",
      ".custCartMnPageeRtBtm table",
      ".custCartMnPageeRtBtm .cart-checkout-button",
      ".custContinewShpngg",
      ".custContinewShpnggList",
      ".custBlgBnrData",
      ".custAllBlogsSecDataTp",
      ".custAllBlogsSecDataBtmLft",
      ".custSingleBlogBanner .slideshow__text-wrapper.banner__content .slideshow__text.banner__box",
      ".custAthrTpData",
      ".custContentLeft",
      ".custContentRight",
    ];
    animatedClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
          opacity: 0,
          y: 50,
          duration: 1.3,
          delay: 0.1,
          ease: "power3.out",
        });
      });
    });

    const rtlAnimatedClasses = [
      ".custHomeSec5 .gallery-item",
      ".custHomeSec7 ul li",
      ".custHomeSec2 ul li:last-child",
      ".custom-bottom-image",
      ".coming-from-right",
      ".image-slide-right",
      ".custHomeSec6 .video-section deferred-media.video-section__media",
      ".custHomeSec3 .multicolumn slider-component ul li:nth-child(3)",
      ".custAboutSec1 .isolate p",
      ".custSustainabilitySec4 slider-component ul.multicolumn-list li.multicolumn-list__item",
      ".custProPfloMnTpRt",
      ".custSnglProSec4MnRpt",
      ".custAllBlogsSecDataBtmRt",
      ".custSingleBlogSec2",
    ];
    rtlAnimatedClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
          opacity: 0,
          x: 100,
          duration: 1.3,
          delay: 0.1,
          ease: "power2.out",
        });
      });
    });

    const ltrAnimatedClasses = [
      ".custHomeSec2 ul li:first-child",
      ".custHomeSec3 .multicolumn slider-component ul li:nth-child(1)",
      ".custAboutSec1 .isolate h2",
      ".image-with-text-logos .image-part img",
      ".custAboutSec4.custSustainabilitySec5 .image-with-text-logos .image-part img",
      ".custProPfloMnTpLft",
      ".custSnglProTpLft",
      ".custSnglProSec3MnLft",
    ];
    ltrAnimatedClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
          opacity: 0,
          x: -100,
          duration: 1.3,
          delay: 0.1,
          ease: "power2.out",
        });
      });
    });

    const ttbAnimatedClasses = ["body.new-home header"];
    ttbAnimatedClasses.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
          opacity: 0,
          y: -50,
          duration: 1.3,
          delay: 0.1,
          ease: "power2.out",
        });
      });
    });
  }

  const header = document.querySelector("header");
  const body = document.body;
  let lastScrollY = window.scrollY;

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;
    if (!header) return;
    if (currentScrollY > lastScrollY && currentScrollY > 120) {
      header.classList.add("to-bottom");
      body.classList.add("adrFxdd");

      header.classList.add("custHdrTranslateMinus");
      header.classList.remove("custNewHdrAnim");
    } else if (currentScrollY === 0) {
      header.classList.remove("to-bottom");
      body.classList.remove("adrFxdd");

      header.classList.remove("custHdrTranslateMinus");
      header.classList.remove("custNewHdrAnim");
    } else if (currentScrollY < lastScrollY) {
      header.classList.add("to-bottom");
      body.classList.add("adrFxdd");

      header.classList.remove("custHdrTranslateMinus");
      header.classList.add("custNewHdrAnim");
    }

    lastScrollY = currentScrollY;
  });

  $(".custMobileHdr .custMobileHdrBtn").click(function () {
    $(this).parents(".custMobileHdr").toggleClass("active");
    $("body").toggleClass("custMobileHdrActive");
  });

  if (window.innerWidth <= 767) {
    $(".custDwnIcn").appendTo(".second-section .bottom-part");

    $("footer .footer-blk .footer-three h3").click(function () {
      $(this).parents("footer .footer-blk .footer-three").toggleClass("active");
    });
  }

  gsap.registerPlugin(ScrollTrigger);

  let container = document.querySelector(
    ".custAnimatedVideoSec .video-section__media.deferred-media.gradient.global-media-settings",
  );
  let totalScroll = container.scrollWidth - container.clientWidth;

  gsap.to(
    [
      ".custAnimatedVideoSec .video-section__media.deferred-media.gradient.global-media-settings",
      ".custAnimatedVideoSec .custVideoTxtDataCld",
    ],
    {
      x: () => -totalScroll,
      ease: "none",
      scrollTrigger: {
        trigger: ".custAnimatedVideoSec",
        start: "top top",
        end: "+=2000",
        scrub: true,
        pin: true,
      },
    },
  );

  document.getElementById(
    "NewsletterForm--template--17529979502694__newsletter_wGRhcV",
  ).placeholder = "Email Address";
  $(".custAnkrLinkImg .video-section__media").append(
    '<a href="/pages/sustainability"></a>',
  );
});

document.addEventListener("DOMContentLoaded", function () {
  var checkExist = setInterval(function () {
    var container = document.querySelector(".custVideoTextLast");
    if (!container) return;
    if (
      container.querySelector(".custVideoLeft") ||
      container.querySelector(".custVideoRight")
    ) {
      clearInterval(checkExist);
      return;
    }
    var leftDiv = document.createElement("div");
    leftDiv.className = "custVideoLeft";
    var rightDiv = document.createElement("div");
    rightDiv.className = "custVideoRight";
    Array.from(container.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName)) {
        leftDiv.appendChild(node);
      } else if (
        node.nodeType === 1 ||
        (node.nodeType === 3 && node.textContent.trim() !== "")
      ) {
        rightDiv.appendChild(node);
      }
    });
    container.innerHTML = "";
    container.appendChild(leftDiv);
    container.appendChild(rightDiv);
    clearInterval(checkExist);
  }, 300);
});

document.addEventListener("DOMContentLoaded", function () {
  const cartLink = document.querySelector(".header-right a.cart-link");
  if (cartLink) {
    cartLink.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = "/cart";
    });
  }
});

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const safeLog = (...args) => {
      try {
        console.log("[GALLERY]", ...args);
      } catch (e) {}
    };
    const wait = (ms) => new Promise((res) => setTimeout(res, ms));
    const modal = document.querySelector(".zoom-modal");
    const modalImg = document.getElementById("zoom-main");
    const closeBtn = document.querySelector(".close-modal");
    const thumbsContainer = document.querySelector(".zoom-thumbs");
    const prevBtn = document.querySelector(".arrow.prev");
    const nextBtn = document.querySelector(".arrow.next");

    if (!modal || !modalImg || !thumbsContainer) {
      safeLog("Required modal elements missing.");
      return;
    }

    const hasSlick = window.$ && $.fn.slick;
    let isSlickInitialized = false;
    let productImages = [];
    let currentIndex = 0;
    let initializationAttempts = 0;
    const MAX_ATTEMPTS = 3;

    function areSliderElementsReady() {
      const sliderFor = document.querySelector(".slider-for");
      const sliderNav = document.querySelector(".slider-nav");

      if (!sliderFor || !sliderNav) return false;

      const forImages = sliderFor.querySelectorAll("img");
      const navImages = sliderNav.querySelectorAll("img");

      return forImages.length > 0 && navImages.length > 0;
    }

    async function initializeSlickSlider(force = false) {
      if (!hasSlick) {
        safeLog("Slick not available");
        return false;
      }

      if (isSlickInitialized && !force) return true;

      try {
        const sliderFor = $(".slider-for");
        const sliderNav = $(".slider-nav");

        if (sliderFor.length === 0 || sliderNav.length === 0) {
          safeLog("Slider elements not found");
          return false;
        }

        if (sliderFor.find("img").length === 0) {
          safeLog("No images in slider yet");
          return false;
        }

        if (sliderFor.hasClass("slick-initialized")) {
          sliderFor.slick("unslick");
          await wait(200);
        }
        if (sliderNav.hasClass("slick-initialized")) {
          sliderNav.slick("unslick");
          await wait(200);
        }

        await wait(300);

        sliderFor[0].style.display = "none";
        sliderFor[0].offsetHeight;
        sliderFor[0].style.display = "";

        sliderFor.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          fade: true,
          asNavFor: ".slider-nav",
          adaptiveHeight: false,
          infinite: false,
          lazyLoad: "ondemand",
          speed: 300,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                fade: true,
                speed: 300,
              },
            },
          ],
        });

        await wait(200);

        sliderNav.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: ".slider-for",
          focusOnSelect: true,
          arrows: false,
          infinite: false,
          lazyLoad: "ondemand",
          speed: 300,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                speed: 300,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                speed: 300,
              },
            },
          ],
        });

        setTimeout(() => {
          if (sliderFor.hasClass("slick-initialized")) {
            window.dispatchEvent(new Event("resize"));
            sliderFor.slick("setPosition");
          }
          if (sliderNav.hasClass("slick-initialized")) {
            sliderNav.slick("setPosition");
          }
        }, 500);

        isSlickInitialized = true;
        initializationAttempts = 0;
        safeLog("Slick slider initialized successfully");

        await wait(300);
        collectProductImages();
        attachOpenListeners();

        return true;
      } catch (err) {
        safeLog("Slick initialization error:", err);
        return false;
      }
    }

    function collectProductImages(retryCount = 0) {
      let imgs = [];
      imgs = Array.from(
        document.querySelectorAll(".slider-for img:not(.slick-cloned)"),
      );

      if (imgs.length === 0) {
        imgs = Array.from(document.querySelectorAll(".product-main-image"));
      }

      if (imgs.length === 0) {
        imgs = Array.from(document.querySelectorAll(".product__media img"));
      }

      if (imgs.length === 0) {
        const sliderFor = document.querySelector(".slider-for");
        if (sliderFor) {
          imgs = Array.from(sliderFor.querySelectorAll('img[src*="product"]'));
        }
      }

      productImages = imgs.filter((img, i, arr) => {
        const src =
          img.src || img.getAttribute("data-src") || img.getAttribute("srcset");
        return (
          src &&
          arr.findIndex(
            (item) => (item.src || item.getAttribute("data-src")) === src,
          ) === i
        );
      });

      safeLog("Collected product images:", productImages.length);

      if (productImages.length === 0 && retryCount < 3) {
        setTimeout(() => collectProductImages(retryCount + 1), 500);
      } else if (productImages.length > 0) {
        attachOpenListeners();
      }

      return productImages.length;
    }

    function attachOpenListeners() {
      productImages.forEach((img, i) => {
        if (img.dataset.galleryBound) return;
        img.dataset.galleryBound = "1";

        const openHandler = async function (e) {
          e.preventDefault();
          e.stopPropagation();
          await openModalAt(i);
        };

        img.addEventListener("click", openHandler);
      });
    }

    function buildThumbs(activeIndex) {
      thumbsContainer.innerHTML = "";
      productImages.forEach((img, i) => {
        const thumb = document.createElement("img");
        thumb.src =
          img.getAttribute("data-zoom-src") ||
          img.getAttribute("data-src") ||
          img.src;
        thumb.className = "modal-thumb";
        thumb.alt = `Thumbnail ${i + 1}`;
        thumb.loading = "lazy";

        if (i === activeIndex) {
          thumb.classList.add("active");
        }

        thumb.addEventListener("click", async function (e) {
          e.preventDefault();
          e.stopPropagation();
          await showImage(i);
          await syncMainSlider(i);
        });

        thumbsContainer.appendChild(thumb);
      });
    }

    async function syncMainSlider(i) {
      currentIndex = i;
      if (hasSlick && isSlickInitialized) {
        try {
          const sliderFor = $(".slider-for");
          const sliderNav = $(".slider-nav");

          if (sliderFor.hasClass("slick-initialized")) {
            sliderFor.slick("slickGoTo", i, true);
          }

          if (sliderNav.hasClass("slick-initialized")) {
            sliderNav.slick("slickGoTo", Math.max(0, i - 1), true);
          }
        } catch (e) {
          safeLog("Sync error:", e);
        }
      }
    }

    async function showImage(index) {
      if (!productImages.length) return;

      index = Math.max(0, Math.min(index, productImages.length - 1));
      currentIndex = index;

      const imgElement = productImages[index];
      const zoomSrc =
        imgElement.getAttribute("data-zoom-src") ||
        imgElement.getAttribute("data-src") ||
        imgElement.src;

      modalImg.src = zoomSrc;
      modalImg.alt = imgElement.alt || `Product image ${index + 1}`;

      const thumbs = thumbsContainer.querySelectorAll("img");
      thumbs.forEach((t, i) => t.classList.toggle("active", i === index));
    }

    async function openModalAt(index) {
      try {
        if (!isSlickInitialized) {
          const initialized = await initializeSlickSlider();
          if (!initialized) {
            safeLog("Could not initialize slider");
          }
        }

        if (productImages.length === 0) {
          collectProductImages();
          await wait(300);

          if (productImages.length === 0) {
            safeLog("No product images found");
            return;
          }
        }

        modal.style.display = "flex";
        modal.style.opacity = "0";
        document.body.style.overflow = "hidden";

        modal.offsetHeight;

        modal.classList.add("active");
        modal.style.opacity = "1";

        buildThumbs(index);
        await showImage(index);
        await syncMainSlider(index);

        setTimeout(() => {
          modal.scrollTop = 0;
        }, 100);

        safeLog("Modal opened at index:", index);
      } catch (error) {
        safeLog("Error opening modal:", error);
      }
    }

    async function closeModal() {
      modal.classList.remove("active");
      modal.style.opacity = "0";
      await wait(300);
      modal.style.display = "none";
      document.body.style.overflow = "";

      if (hasSlick && isSlickInitialized) {
        try {
          const sliderFor = $(".slider-for");
          const sliderNav = $(".slider-nav");

          if (sliderFor.hasClass("slick-initialized")) {
            sliderFor.slick("setPosition");
          }
          if (sliderNav.hasClass("slick-initialized")) {
            sliderNav.slick("setPosition");
          }
        } catch (e) {
          safeLog("Refresh error:", e);
        }
      }
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (productImages.length > 0) {
          currentIndex =
            (currentIndex - 1 + productImages.length) % productImages.length;
          showImage(currentIndex);
          syncMainSlider(currentIndex);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (productImages.length > 0) {
          currentIndex = (currentIndex + 1) % productImages.length;
          showImage(currentIndex);
          syncMainSlider(currentIndex);
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          closeModal();
        }
      });
      modal
        .querySelector(".modal-content")
        ?.addEventListener("touchstart", (e) => {
          e.stopPropagation();
        });
    }

    document.addEventListener("keydown", function (e) {
      if (!modal.classList.contains("active")) return;

      if (e.key === "Escape") {
        closeModal();
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        if (productImages.length > 0) {
          currentIndex =
            (currentIndex - 1 + productImages.length) % productImages.length;
          showImage(currentIndex);
          syncMainSlider(currentIndex);
        }
      }
      if (e.key === "ArrowRight") {
        e.preventDefault();
        if (productImages.length > 0) {
          currentIndex = (currentIndex + 1) % productImages.length;
          showImage(currentIndex);
          syncMainSlider(currentIndex);
        }
      }
    });

    async function init() {
      safeLog("Initializing gallery...");
      await wait(200);
      const initAttempt = async (attempt = 1) => {
        const ready = areSliderElementsReady();

        if (ready || attempt >= MAX_ATTEMPTS) {
          await initializeSlickSlider();
          collectProductImages();
        } else {
          safeLog(`Initialization attempt ${attempt} failed, retrying...`);
          await wait(1000);
          await initAttempt(attempt + 1);
        }
      };
      await initAttempt();
      window.addEventListener("load", () => {
        setTimeout(() => {
          if (!isSlickInitialized || productImages.length === 0) {
            safeLog("Post-load initialization");
            initializeSlickSlider(true);
            collectProductImages();
          }
          if (isSlickInitialized) {
            $(".slider-for, .slider-nav").slick("setPosition");
          }
        }, 1000);
      });
      window.addEventListener("orientationchange", () => {
        setTimeout(() => {
          if (isSlickInitialized) {
            $(".slider-for, .slider-nav").slick("setPosition");
          }
        }, 300);
      });
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (isSlickInitialized) {
            try {
              $(".slider-for, .slider-nav").slick("setPosition");
            } catch (e) {
              safeLog("Resize error:", e);
            }
          }
        }, 250);
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", (e) => {
      safeLog("Section loaded");
      isSlickInitialized = false;
      setTimeout(init, 500);
    });

    document.addEventListener("shopify:section:unload", () => {
      isSlickInitialized = false;
      productImages = [];
    });
  });
})();

$(window).on("load", function () {
  $(".custSearchPageMain #product-grid ul li img").each(function () {
    const src = $(this).attr("src");
    if (src && /\.(jpg|jpeg)(\?|$)/i.test(src)) {
      $(this).closest("li").addClass("has-jpg");
    }
  });
});
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  const section = document.querySelector("#custProductVideoSec");
  if (!section) return;

  const videoEl = section.querySelector("video, iframe");
  if (!videoEl) return;

  let videoType = "mp4";
  if (videoEl.tagName.toLowerCase() === "iframe") {
    const src = videoEl.src || "";
    if (src.includes("youtube")) videoType = "youtube";
    else if (src.includes("vimeo")) videoType = "vimeo";
  }
  const controlVideo = (action) => {
    if (videoType === "mp4") {
      action === "play" ? videoEl.play().catch(() => {}) : videoEl.pause();
    } else if (videoType === "youtube") {
      const command = action === "play" ? "playVideo" : "pauseVideo";
      try {
        videoEl.contentWindow.postMessage(
          `{"event":"command","func":"${command}","args":""}`,
          "*",
        );
      } catch (e) {}
    } else if (videoType === "vimeo") {
      const player = new Vimeo.Player(videoEl);
      action === "play"
        ? player.play().catch(() => {})
        : player.pause().catch(() => {});
    }
  };
  if (videoType === "mp4") {
    videoEl.muted = true;
    videoEl.loop = true;
    videoEl.removeAttribute("controls");
    videoEl.setAttribute("playsinline", "");
    videoEl.style.pointerEvents = "none";
  } else if (videoType === "youtube") {
    videoEl.src = updateYouTubeURL(videoEl.src);
    videoEl.setAttribute("allow", "autoplay; encrypted-media");
  } else if (videoType === "vimeo") {
    videoEl.src = updateVimeoURL(videoEl.src);
  }
  ScrollTrigger.create({
    trigger: section,
    start: "top 95%",
    end: "bottom 5%",
    onEnter: () => controlVideo("play"),
    onEnterBack: () => controlVideo("play"),
    onLeave: () => controlVideo("pause"),
    onLeaveBack: () => controlVideo("pause"),
    onUpdate: (self) => {
      if (self.isActive && videoType === "mp4" && videoEl.paused) {
        videoEl.play().catch(() => {});
      }
    },
  });

  function updateYouTubeURL(src) {
    let base = src.split("?")[0];
    const params = new URLSearchParams(src.split("?")[1] || "");
    params.set("autoplay", "1");
    params.set("mute", "1");
    params.set("loop", "1");
    params.set("controls", "0");
    params.set("enablejsapi", "1");
    params.set("modestbranding", "1");
    const idMatch = base.match(/embed\/([a-zA-Z0-9_-]+)/);
    if (idMatch) params.set("playlist", idMatch[1]);
    return `${base}?${params.toString()}`;
  }

  function updateVimeoURL(src) {
    let base = src.split("?")[0];
    const params = new URLSearchParams(src.split("?")[1] || "");
    params.set("autoplay", "1");
    params.set("muted", "1");
    params.set("loop", "1");
    params.set("background", "1");
    return `${base}?${params.toString()}`;
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const emailSignup = document.querySelector(".custHmeEmlSgnup");
  if (emailSignup) {
    const shopifySection = emailSignup.closest(".shopify-section");
    if (shopifySection) {
      shopifySection.classList.add("custHmeEmlSgnupMn");
    }
  }
});
(function () {
  const r = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  const f = () => {
    document.querySelectorAll(".rivo-login-subtitle").forEach((e) => {
      if (e.dataset.l) return;
      const h = e.innerHTML;
      if (r.test(h)) {
        e.innerHTML = h.replace(r, (m) => `<a href="mailto:${m}">${m}</a>`);
        e.dataset.l = 1;
      }
    });
  };
  f();
  new MutationObserver(f).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(
    "#shopify-section-template--18459881209958__collapsible_content_yh8aHw .accordion details",
  );

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (this.open) {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== this) {
            otherAccordion.removeAttribute("open");
          }
        });
      }
    });
  });
});
(function () {
  const findAndFix = () => {
    const cells = document.querySelectorAll(
      ".rivo-vip-tier-table thead td, .rivo-vip-tier-table thead th, .rivo-vip-tier-table td",
    );
    if (cells.length === 0) {
      return;
    }
    cells.forEach((td) => {
      if (td.textContent.trim() === "." && !td.querySelector(".dot-span")) {
        td.innerHTML =
          '<span class="dot-span" style="display:inline-block; width:10px; height:10px; background:black; border-radius:50%; position: relative; left: 15px;"></span>';
      }
    });
  };
  const timer = setInterval(findAndFix, 1000);
  setTimeout(() => clearInterval(timer), 10000);
})();

(function () {
  function addRivoLinks() {
    const steps = [
      { className: ".rivo-first-step", id: "#rivo" },
      { className: ".rivo-second-step", id: "#rivo-ways-to-earn" },
      {
        className: ".rivo-third-step",
        id: "#shopify-block-AT3ZUblJ6ZUhVWjIye__rivo_loyalty_rewards_referrals_lp_ways_to_redeem_gM86Rh",
      },
    ];

    steps.forEach((step) => {
      const container = document.querySelector(step.className);

      if (container && !container.querySelector("a.custom-rivo-link")) {
        const link = document.createElement("a");
        link.href = step.id;
        link.className = "custom-rivo-link";

        link.style.display = "block";
        link.style.width = "100%";

        container.appendChild(link);
        console.log(`Link added to ${step.className}`);
      }
    });
  }

  const linkInterval = setInterval(addRivoLinks, 1000);
  setTimeout(() => clearInterval(linkInterval), 10000);

  const observer = new MutationObserver(addRivoLinks);
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function syncRivoHeaderActive() {
    const activeBodyCell = document.querySelector(
      "tbody .rivo-vip-tier-active",
    );
    if (!activeBodyCell) return;
    const activeText = activeBodyCell.textContent.trim();
    const headerCells = document.querySelectorAll(
      "table.rivo-vip-tier-table thead th, table.rivo-vip-tier-table thead td",
    );
    headerCells.forEach((cell) => {
      const cellText = cell.textContent.trim();
      if (cellText.includes(activeText)) {
        if (!cell.classList.contains("rivo-vip-tier-active")) {
          cell.classList.add("rivo-vip-tier-active");
          console.log("Header Matched and Updated:", activeText);
        }
      } else {
        if (!cell.classList.contains("rivo-vip-tier-table-thead-first-cell")) {
          cell.classList.remove("rivo-vip-tier-active");
        }
      }
    });
  }
  const syncInterval = setInterval(syncRivoHeaderActive, 1000);
  setTimeout(() => clearInterval(syncInterval), 10000);
  const observer = new MutationObserver(syncRivoHeaderActive);
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  let isSynced = false;
  function syncRivoData() {
    if (isSynced) return;
    const pointsSpan = document.querySelector(
      '#rivo-lp-explainer .rivo-lp-section-title span[rivo-x-text*="points_tally"]',
    );
    const firstButton = document.querySelector(
      "body.custUserLoggedIn #rivo-lp-header .rivo-hero-buttons .rivo-button:first-child",
    );
    const lastButton = document.querySelector(
      "body.custUserLoggedIn #rivo-lp-header .rivo-hero-buttons .rivo-button:last-child",
    );
    if (lastButton) {
      lastButton.setAttribute("href", "/pages/product-collection");
      if (lastButton.tagName !== "A") {
        lastButton.onclick = function () {
          window.location.href = "/pages/product-collection";
        };
      }
    }
    if (pointsSpan && firstButton) {
      const pointsValue = pointsSpan.innerText.trim();
      if (pointsValue !== "" && pointsValue !== "0") {
        firstButton.innerText = pointsValue + " Points";
        isSynced = true;
        pointsObserver.disconnect();
      }
    }
  }
  let debounceTimer;
  const pointsObserver = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncRivoData, 200);
  });
  pointsObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  const pInterval = setInterval(syncRivoData, 2000);
  setTimeout(() => clearInterval(pInterval), 10000);
})();

const wrapAndCleanTable = () => {
  const table = document.querySelector(
    ".custMtrlsListData2.table-responsive .custom-table",
  );
  if (!table) return;
  let wrapper = table.parentElement;
  if (!wrapper.classList.contains("custNwTblRspnsv")) {
    wrapper = document.createElement("div");
    wrapper.className = "custNwTblRspnsv";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
  const appBlocks = wrapper.querySelectorAll(
    '.shopify-app-block, .shopify-block, [class*="shopify-app"]',
  );
  appBlocks.forEach((block) => {
    wrapper.parentNode.insertBefore(block, wrapper);
  });
};
const observer = new MutationObserver(() => {
  wrapAndCleanTable();
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
wrapAndCleanTable();
setTimeout(wrapAndCleanTable, 1000);
setTimeout(wrapAndCleanTable, 3000);

document.addEventListener("DOMContentLoaded", function () {
  const consentHTML = `
        <p class="newsletter-consent-text">
            By submitting this form and subscribing, you agree to receive marketing emails from Dexon, including promotional offers, product updates, and exclusive content.
            Consent is not a condition of purchase. You can unsubscribe at any time by clicking the unsubscribe link in our emails.
            For more information, please refer to our
            <a href="/pages/privacy-policy">Privacy Policy</a> and
            <a href="/pages/legal">Terms &amp; Conditions</a>.
        </p>
    `;
  function addConsentText(successMessage) {
    if (!successMessage.querySelector(".newsletter-consent-text")) {
      successMessage.insertAdjacentHTML("beforeend", consentHTML);
    }
  }
  document
    .querySelectorAll(
      ".newsletter-form__message.newsletter-form__message--success.form__message",
    )
    .forEach(addConsentText);
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === 1 &&
          node.matches?.(
            ".newsletter-form__message.newsletter-form__message--success.form__message",
          )
        ) {
          addConsentText(node);
        }
      });
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
